(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('RouteType', RouteType);

    RouteType.$inject = ['$resource', 'DateUtils'];

    function RouteType ($resource, DateUtils) {
        var resourceUrl =  'api/route-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('RouteTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getroutetypebyname = function (data,callback){
		$http.get('api/route-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('RouteTypeSearch', RouteTypeSearch);

    RouteTypeSearch.$inject = ['$resource'];

    function RouteTypeSearch ($resource) {
        var service = $resource('/api/route-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomRouteTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-route-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();